var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 36,
    fill: "none",
    viewBox: "0 0 25 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 34,
    fill: "#091F34",
    opacity: 0.3,
    rx: 7.5,
    ry: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5384F",
    fillRule: "evenodd",
    d: "M24.818 12.176C24.818 5.452 19.263 0 12.41 0h.001-.002.001C5.556 0 0 5.452 0 12.176c0 2.446.801 4.683 2 6.631 2.757 4.478 10.41 15.557 10.41 15.557s7.651-11.08 10.408-15.557c1.2-1.948 2-4.185 2-6.631zM12.41 7.636a4.773 4.773 0 1 0 0 9.546 4.773 4.773 0 0 0 0-9.546z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerRed);
export default __webpack_public_path__ + "static/media/marker-red.f9015c37a4e69341548e0853bf8aaa18.svg";
export { ForwardRef as ReactComponent };